import { render } from "./LoaderComponent2.vue?vue&type=template&id=83a38724&scoped=true"
import script from "./LoaderComponent2.vue?vue&type=script&lang=js"
export * from "./LoaderComponent2.vue?vue&type=script&lang=js"

import "./LoaderComponent2.vue?vue&type=style&index=0&id=83a38724&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a38724"]])

export default __exports__